/**
 * Constants for inactivity timer localStorage keys
 */
export const MEDIA_PLAYING_TIMESTAMP_KEY = '@mediaPlayingTimestamp';
